import { Plan } from '@springbig/shared';
import { Box, VStack } from 'native-base';
import { Caption, H2 } from '~/shared/Typography';
import Confetti from '~/pages/subscriptions/components/Confetti';
import React from 'react';
import { Button } from '~/shared/Theme';

type SubscribeSuccessScreenProps = {
    plan: Plan;
    onProceed: (destination: Destinations) => void;
};

export type Destinations = 'subscriptions' | 'offers';

const SubscribeSuccessScreen = ({ plan, onProceed }: SubscribeSuccessScreenProps) => {

    return (
        <VStack textAlign={'center'} px={4} space={8}>

            <Confetti />

            <H2 text={'subscriptions.success.title'} textValues={[plan.name]} />
            <Box>
                <Caption
                    text={'subscriptions.success.description'}
                    textValues={[plan.name]}
                />
                <Caption text={'subscriptions.success.description_two'} />
            </Box>

            <VStack space={4}>
                { plan.has_offers &&
                    <Button
                        text={'subscriptions.success.view_offers_button'}
                        onPress={() => onProceed('offers')}
                    />
                }
                <Button
                    text={'subscriptions.back_button'}
                    onPress={() => onProceed('subscriptions')}
                />
            </VStack>
        </VStack>
    );
};

export default SubscribeSuccessScreen;
